module.exports = __webpack_public_path__ + "img/2.ff565b8a.png";